import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  icon: {
    flexShrink: 0
  }
}))

export default useStyles
